module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.a982c7a7.xml";